import React, { ReactNode } from 'react'
import { Box } from '@node-space/ui-components'
import { Description } from 'components/Text'

export interface VerificationIntroductionProps {
  textList: ReactNode[]
  hasPadding?: boolean
  hasTopPadding?: boolean
  hasBottomPadding?: boolean
}

export const VerificationIntroduction = ({
  textList,
  hasPadding,
  hasTopPadding,
  hasBottomPadding,
}: VerificationIntroductionProps) => {
  return (
    <Box
      flexCol
      gap={16}
      {...((hasPadding || hasTopPadding) && { paddingT: 16 })}
      {...((hasPadding || hasBottomPadding) && { paddingB: 24 })}
    >
      {textList.map((textItem, index) => (
        <Description key={`verification-introduction-${index}`}>{textItem}</Description>
      ))}
    </Box>
  )
}
